import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TrendingCategoriesState } from './trending-categories.reducer';

export const selectTrendingCategoriesState =
  createFeatureSelector<TrendingCategoriesState>('trendingCategories');

export const selectParentCategories = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.parentCategories,
);

export const selectAllOffers = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.allOffers,
);

export const selectFilteredOffers = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.filteredOffers,
);

export const selectSelectedCategoryId = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.selectedCategoryId,
);

export const selectTrendingCategoriesLoading = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.loading,
);

export const selectTrendingCategoriesError = createSelector(
  selectTrendingCategoriesState,
  (state: TrendingCategoriesState) => state.error,
);

export const selectHasTrendingData = createSelector(
  selectParentCategories,
  (categories) => categories.length > 0,
);
